import { AutomatorBuilderPublishSetting } from '../_base';
import { customElement } from 'lit/decorators.js';

// Import global utils
import { openWindow } from '@automator/shared/utils/open-window';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __ } from '@wordpress/i18n';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-publish-setting-user-type' )
export class AutomatorBuilderPublishSettingUserType extends AutomatorBuilderPublishSetting {
	// Unique identifier for this setting.
	settingID = 'recipe_user_type';

	// Icon representing this setting in the UI.
	icon = 'user';

	// Label displayed for this setting in the UI.
	label = escapeHTML( __( 'User type', 'uncanny-automator' ) );

	// Define the helper text for the setting.
	helper = escapeHTML( __( 'Specifies which user group can trigger this recipe, such as logged-in users or all users.', 'uncanny-automator' ) );

	/**
	 * Retrieves a readable version of the "User type" field value for display.
	 *
	 * @return {String|undefined} The type of user
	 */
	get readableValue() {
		// Get the value of the field "User type"
		const userType = this.getFieldValue( 'USER_TYPE' );

		if ( userType == 'user' ) {
			return escapeHTML( __( 'Logged-in users', 'uncanny-automator' ) );
		}

		if ( userType == 'anonymous' ) {
			return escapeHTML( __( 'Everyone', 'uncanny-automator' ) );
		}
	}

	/**
	 * Opens the helper for the setting.
	 */
	helperCallback() {
		openWindow( {
			url: 'https://automatorplugin.com/knowledge-base/creating-a-recipe/?utm_source=uncanny-automator&utm_medium=in-plugin&utm_content=publish-metabox-recipe-type-question-icon',
			w: 450
		} )
	}
}
